import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useConfigurationContext } from '../../contexts/ConfigurationContext';
import { Client as client } from './ClientProvider';
export var useChangePasswordMetadataQuery = function useChangePasswordMetadataQuery() {
  var apiClient = client();

  var _useConfigurationCont = useConfigurationContext(),
      tenant = _useConfigurationCont.tenant;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      metadata = _useState2[0],
      setMetadata = _useState2[1];

  useEffect(function () {
    var fetchMetadata = async function fetchMetadata() {
      try {
        var metadataResponse = await apiClient.getAccountsChangePasswordMetadata(tenant);

        var isSuccess = metadataResponse._response.status.toString().startsWith('2');

        if (isSuccess) {
          setMetadata(metadataResponse._response.parsedBody);
        } else {
          setMetadata(undefined);
        }
      } catch (error) {
        setMetadata(undefined);
      }
    };

    fetchMetadata(); // eslint-disable-next-line react-hooks/exhaustive-deps -- not needed
  }, []);
  return metadata;
};